import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { ProgressNode } from "../types";

export interface CompletionManagement {
  status?: string | null;
  completionDateTime?: string | null;
  exemptionDateTime?: string | null;
  score?: number | null;
}

export const buildCompletionManagementUrl = (
  corporateId: string | number,
  userId: string | number,
  node: ProgressNode,
): string => {
  const params = new URLSearchParams({
    corporateId: String(corporateId),
    userId: String(userId),
    objectId: String(node.id),
  });
  if (node.parentActivityId != null)
    params.set("parentId", String(node.parentActivityId));
  if (node.grandparentActivityId != null)
    params.set("grandparentId", String(node.grandparentActivityId));
  return `${ServicesURL.getCompletionManagement}?${params.toString()}`;
};

export const fetchCompletionManagement = (
  url: string,
): Promise<CompletionManagement> =>
  fetcher<CompletionManagement>(url, MethodType.GET);
